import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import './Login.css';

const ChangePasswordbeforelogin = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const mobile = state?.mobile;

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // 🔒 Prevent direct access
  if (!mobile) {
    navigate('/forgot-password');
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        'https://playinbyd.com/api/api-change-password-mpin',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            app_key: 'SgRTXsywVmWteEBLlYWecwgbDiHwlh',
            env_type: 'Prod',
            mobile: mobile,
            password: password
          })
        }
      );

      const data = await res.json();
      console.log('Change password response:', data);

      if (data.success) {
        toast.success(data.msg || 'Password changed successfully');
        navigate('/login');
      } else {
        toast.error(data.msg || 'Failed to change password');
      }
    } catch (err) {
      console.error(err);
      toast.error('Server error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Change Password</h2>
          <p className="input-hint">
            Set a new password for <strong>{mobile}</strong>
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>New Password *</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value.trim())}
              placeholder="Enter new password"
              disabled={loading}
            />
            <div className="input-hint">Minimum 6 characters</div>
          </div>

          <div className="form-group">
            <label>Confirm Password *</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value.trim())}
              placeholder="Confirm new password"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className={`login-btn ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? 'Updating...' : 'Change Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordbeforelogin;
